import * as Yup from "yup";

export const validationSchema = Yup.object({
  username: Yup.string().min(2, "Имя должно содержать минимум 2 символа").max(50, "Имя не может превышать 50 символов").required("Имя обязательно для заполнения"),
  email: Yup.string().email("Некорректный email").required("Email обязателен для заполнения"),
  password: Yup.string().min(6, "Пароль должен содержать минимум 6 символов").required("Пароль обязателен для заполнения"),
  confirmPassword: Yup.string().oneOf([Yup.ref("password"), null], "Пароли должны совпадать").required("Подтверждение пароля обязательно"),
});